<template>
  <div class="jin-m-list jin-m">
    <ZpProcess v-show="$route.query.attributes==='0'" />
    <div class="jin-list-con">
      <div class="jin-list-position-warp">
        <div v-sticky="{ zIndex: 99, stickyTop: 0}">
          <ul class="jin-m-category-warp">
            <li v-for="item in category" :key="item.key" class="jin-m-category-item" :class="{'jin-m-category-item-active' : item.name === active}" @click="onChange(item)">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="jin-m-container">
          <List ref="list" :show-page="false" :show="false" :query="query" @finish="onFinish" @loading="onLoading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSticky from 'vue-sticky'
import myMixin from '@/minxin/list'
import { mapMutations, mapGetters } from 'vuex'
import ZpProcess from '@/components/ZpProcess'

export default {
  components: {
    ZpProcess
  },
  directives: {
    'sticky': VueSticky
  },
  mixins: [myMixin],
  data() {
    return {
      loading: false,
      finished: false,
      active: '',
      text: ''
    }
  },
  computed: {
    ...mapGetters([
      'list',
      'total',
      'category'
    ]),
    currActive() {
      return this.$route.query.title
    }
  },
  watch: {
    total() {
      this.text = this.total ? '没有更多了' : ''
    },
    active(n) {
      this.init()
    },
    category: {
      handler() {
        this.onLoad()
      }
    }
  },
  created() {
    this.init()
    this.RESET_LIST()
    this.onLoad()
  },
  methods: {
    ...mapMutations('position', ['SET_CATEGORY_TITLE', 'SET_KEY_WORDS', 'RESET_LIST']),
    init() {
      this.active = this.currActive || '全部职位'
      this.SET_CATEGORY_TITLE({
        name: this.currActive,
        id: this.category.length && this.category.find(item => item.name === this.currActive) ? this.category.find(item => item.name === this.currActive).id : ''
      })
    },
    onLoad() {
      this.loading = false
      this.$nextTick(() => {
        if (this.category.length) this.$refs.list && this.$refs.list.handleMobileList()
      })
    },
    onFinish(total) {
      this.finished = true
      this.text = this.total ? '没有更多了' : ''
    },
    onLoading(status) {
      this.loading = status
    },
    onChange(item) {
      this.SET_KEY_WORDS('')
      this.active = item.name
      this.$router.replace({
        path: '/list',
        query: { ...this.$route.query, title: item.name }
      })
      this.SET_CATEGORY_TITLE({ name: item.name, id: item.id })
      this.$refs.list && this.$refs.list.handleMobileList()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/page/list-m.scss'
</style>
